import { jsx } from "react/jsx-runtime";
import CategoryIcon from "@mui/icons-material/Category";
import { validateTidalLicense } from "../../base/index.js";
function Category(props) {
  return /* @__PURE__ */ jsx(
    CategoryIcon,
    {
      "data-testid": "Category",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Category",
      "data-tidal-icon-meta": "miscellaneous"
    }
  );
}
Category.tidalIconMeta = {
  categories: "miscellaneous",
  name: "Category"
};
validateTidalLicense();
export {
  Category
};
//# sourceMappingURL=Category.js.map
